module.exports = __webpack_public_path__ + "img/venezuela-(bolivarian-republic-of).b37838ef.svg";